module.exports = __webpack_public_path__ + "static/img/18-Duke-of-Edinburgh-Scheme-DofE.3f36f1a3.jpg";